import React from "react";
import DashboardIcon from "../icons/DashboardIcon";
import CasesIcon from "../icons/CasesIcon";
import ReportsIcon from "../icons/ReportsIcon";
import ImportExportWizardIcon from "../icons/ImportExportWizardIcon";
import SeedingEntryIcon from "../icons/SeedingEntryIcon";
import SettingIcon from "../icons/SettingIcon";
import ConsentIcon from "../icons/ConsentIcon";
import HelpIcon from "../icons/HelpIcon";

const dashboardLists = [
  {
    title: "Dashboard",
    icon: <DashboardIcon />,
    to: "/",
  },
  {
    title: "Patients",
    icon: <CasesIcon />,
    to: "/patients?tab=all",
    alternateName: ["/patient"],
  },
  { title: "Reports & Insights", icon: <ReportsIcon />, to: "/reports" },
  {
    title: "Import/Export Wizard",
    icon: <ImportExportWizardIcon />,
    to: "/import-export-wizard",
    alternateName: [
      "/import-patients",
      "/assign-patients",
      "/export-patients",
      "/import-export-history",
    ],
  },
  {
    title: "Data Seeding",
    icon: <SeedingEntryIcon />,
    to: "/seeding-entry",
  },
  {
    title: "Settings",
    icon: <SettingIcon />,
    to: "/settings?tab=general",
    alternateName: ["/settings"],
  },
  {
    title: "Terms & Condition",
    icon: <ConsentIcon />,
    to: "/practice-terms",
  },
  {
    title: "Help & Support",
    icon: <HelpIcon />,
    to: "/help",
    className: "helpBottom",
  },
];

export default dashboardLists;
